import { Subject } from "rxjs";

// interfaces
import { ICategory } from "src/app/core/interfaces/category/category";

export class CategoryHandler {
    
    /** 
     * fields
    */
    private _subItems: ICategory[] = null;
    public isLoadingItems: boolean = false;
    public watchChange: Subject<null> = null

    /**
     * 
     * @param _items array of Category
     */
    constructor(private _items: ICategory[]) {
        // init
        this.watchChange = new Subject();        
    }

    /** getters & setters  */

    /**
     * getter items
     */
    public get items(): ICategory[] {

        try {

            if (this._items == null) throw `items is ${this._items}`;

            return this._items;

        } catch (err: any) {
            new Error(err)
            return []
        }
    }

    /**
     * setter subItems
     */    
    public set items(items: ICategory[]) {

        try {

            /**
             * handing Error
             */
            if (items == null || Array.isArray(items) == false) throw `items is ${this.items}`;

            this._items = items;


        } catch (err: any) {
            new Error(err)
        }  
              
    }    

    /**
     * getter subItems
     */
    public get subItems(): ICategory[] {

        try {

            /**
             * handing Error
             */
            if (this._subItems == null) throw `items is ${this._subItems}`;

            return this._subItems;

        } catch (err: any) {
            new Error(err)
            return []
        }

    }
    
    /**
     * setter subItems
     */    
    private set subItems(items: ICategory[]) {

        try {

            /**
             * handing Error
             */
            if (items == null || Array.isArray(items) == false) throw `items is ${this.items}`;

            this._subItems = items;


        } catch (err: any) {
            new Error(err)
        }  
              
    }


    /** Methods */

    /**
     * 
     * @param id main category id
     * @returns array of category
     */
    public findSubCategories(category: ICategory): void {

        // ES6 Destruction
        const { id } = category;
        
        try {

        /**
         * handing Error
         */
        if (id == null) throw `id arg is ${id}`;
        
        // ES6 Destruction
        const { child } = this.items.find((c => c.id == id));

        /**
         * handing Error
         */      
        if (child == null) throw `that not main category & not hasChild`;

        /**
         * fire Observable to note that the values ​​have been changed;
         */
        this.watchChange.next(null)        

        /**
         * 
         */
        this.subItems = child as ICategory[];

        } catch (err: any) {
            new Error(err);
            console.log(err)
        }

    }
    
    
    /**
     * 
     */
    onDestroy(): void {
        this.watchChange.unsubscribe();
    }    
}
